import { useCallback, useEffect, useRef, useState } from 'react';
import backendApi from '../services/backendApi';

const PAGE_SIZE = 5;
export default function useStoryChatter(taskId) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const request = useRef({ version: 0, taskId: null });
  const [criteriaData, setCriteriaData] = useState(null);
  const load = useCallback(async (nextPage = 1) => {
    if (!taskId || request.current.taskId !== taskId) return;
    const current = ++request.current.version;
    setLoading(true);
    setError(null);
    try {
      const initial = !request.current.detailsLoaded;
      const details = initial ? await backendApi.getUserStoryDetails(taskId) : null;
      const data = initial ? details.chatter : await backendApi.getUserStoryMessages(taskId, { page: nextPage, limit: PAGE_SIZE });
      if (current !== request.current.version) return;
      if (!data || typeof data.hasMore !== 'boolean' || !Array.isArray(data.messages) || data.messages.length > PAGE_SIZE) {
        throw new Error('Réponse de pagination invalide');
      }
      if (initial) {
        setCriteriaData({ criteria: details.criteria, progress: details.progress, task: details.task });
        request.current.detailsLoaded = true;
      }
      setMessages(data.messages);
      setHasMore(data.hasMore);
      setPage(nextPage);
    } catch (err) {
      if (current === request.current.version) setError(err.message || 'Impossible de charger cette User Story. Réessayez.');
    } finally {
      if (current === request.current.version) setLoading(false);
    }
  }, [taskId]);
  useEffect(() => {
    const tracker = request.current;
    tracker.taskId = taskId;
    tracker.detailsLoaded = false; setCriteriaData(null);
    setMessages([]); setPage(1); setHasMore(false); setError(null); setLoading(false);
    load();
    return () => { tracker.version++; tracker.taskId = null; };
  }, [load, taskId]);
  const reload = useCallback(() => load(1), [load]);
  return { criteriaData, messages, loading, error, page, hasMore, load, reload };
}
